/**
 * The registry of question types that render with React.
 *
 * Its keys are the list: a question type present here uses a React feature,
 * everything else uses the legacy widget. Its values are lazy loaders, so this
 * module adds zero React to the main bundle — nothing here is downloaded until a
 * listed type is actually created.
 *
 * Convert a widget by adding one line, and give every entry the same
 * `webpackChunkName` so React and the converted components stay one shared
 * download:
 *
 *   single: () => import(
 *     // webpackChunkName: "ReactFeatures"
 *     './single'
 *   ),
 */
import type { FeatureComponent } from '@/types/question';

export type FeatureLoader = () => Promise<{ default: FeatureComponent }>;

export const registry: Record<string, FeatureLoader> = {
  open: () =>
    import(
      /* webpackChunkName: "ReactFeatures" */
      '../../open'
    ),
};
